import { createApi } from '@reduxjs/toolkit/query/react';

import { dynamicBaseQuery } from '@redux/baseQuery';
import { teamsSlice } from '@redux/state/teamsSlice';
import { Team } from '@typings/user';

export const teamApi = createApi({
  reducerPath: 'teamApi',
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getAllTeams: builder.query<Team[], { search: string; isRefresh?: boolean }>(
      {
        query: ({ search = '' }) => ({
          url: '/teams',
          params: { search },
        }),
        onQueryStarted: async ({ isRefresh }, { dispatch, queryFulfilled }) => {
          try {
            const { data } = await queryFulfilled;
            if (isRefresh) {
              dispatch(teamsSlice.actions.setTeams(data?.length ? data : []));
            }
          } catch (error) {
            console.log('getAllTeams error', error);
          }
        },
      },
    ),
  }),
});

export const { useLazyGetAllTeamsQuery } = teamApi;
